'use strict';

var FlightCabinChartFilterFactory = function FlightCabinChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLegFilterFactory', 'FlightDOWFilterFactory', 'FlightSeasonFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightCabinChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-cabin');
    this.registerFilters(injectedFilters);
  }
  FlightCabinChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightCabinChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightCabinChartFilter;
};
FlightCabinChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightCabinChartFilterFactory;